import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  MobileBody2,
  MobileCaption1,
  MobileHeader1,
  WebBody2,
} from "@/system/day/font/font";
import { grayScale, wHeader2 } from "@teamsparta/design-system";
import { swc } from "@teamsparta/design-system";

export const Wrapper = styled.section``;

export const Fix = styled.div<{
  scrollUp: boolean;
}>`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 360px;
  padding: 0 16px;
  top: ${({ scrollUp }) => (scrollUp ? "59px" : "-1px")};
  z-index: 100;
  ${DESKTOP} {
    position: sticky;
    justify-content: space-between;
    flex-direction: row;
    width: 935px;
    padding: 50px 0 0 0;
    box-shadow: inset 0 50px 0 0 white;
  }
`;

export const Text = styled.div`
  ${DESKTOP} {
  }
`;

export const Title = styled.div`
  ${MobileHeader1};
  ${DESKTOP} {
    ${wHeader2};
  }
`;

export const Nav = styled.div`
  display: none;
  ${DESKTOP} {
    display: flex;
    position: sticky;
    margin: 0;
    top: initial;
    padding: 20px 10px 0;
    justify-content: space-between;
    background-color: white;
    width: 421px;
    height: 96px;
    border-bottom: 1px solid ${grayScale.gray10};
  }
`;

export const MobileNav = styled.div<{
  scrollUp: boolean;
}>`
  width: 360px;
  margin: 50px auto;
  display: flex;
  position: sticky;
  top: ${({ scrollUp }) => (scrollUp ? "50px" : "0")};
  padding: 15px 16px;
  justify-content: space-between;
  background-color: white;
  z-index: 20;
  border-bottom: 1px solid ${grayScale.gray10};

  ${DESKTOP} {
    display: none;
  }
`;

export const Step = styled.div<{ intersecting: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  ${MobileBody2};
  font-weight: 500 !important;
  color: ${(props) =>
    props.intersecting
      ? `${swc.blue} !important`
      : `${grayScale.gray80} !important`};
  ${DESKTOP} {
    ${WebBody2};
  }
`;

export const Number = styled.div<{ intersecting: boolean }>`
  ${MobileCaption1};
  color: ${(props) =>
    props.intersecting ? "white !important" : `${grayScale.gray80} !important`};
  width: 24px;
  height: 24px;
  display: flex;
  margin-bottom: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: ${(props) =>
    props.intersecting
      ? `${swc.blue} !important`
      : `${grayScale.gray10} !important`};
  font-weight: 500 !important;
  ${DESKTOP} {
    ${WebBody2};
    width: 30px;
    height: 30px;
    margin-bottom: 10px;
  }
`;

export const Divider = styled.div`
  ${DESKTOP} {
    background-color: ${grayScale.gray10};
    height: 2px;
    position: absolute;
    width: 389px;
    bottom: 60px;
  }
`;

export const MobileDivider = styled(Divider)`
  background-color: ${grayScale.gray10};
  height: 2px;
  position: absolute;
  width: 308px;
  bottom: 53px;
  ${DESKTOP} {
    display: none;
  }
`;
